import React, { Component } from 'react';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import Loader from 'react-loader-spinner';

class Translations extends Component {
  constructor() {
    super(...arguments);
    this.dialogClose = () => {
      this.setState({ hideDialog: false, hideAddDialog: false, hideDeletePopup: false });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchTranslationApi()
        this.dialogClose();
      }
    }];
    //for add dialog component ok click
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchTranslationApi()
        this.dialogClose();
        this.setState({ disabled: false })

      }
    }];
    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteTranslationApi(this.state.propsId)
      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({ hideDeletePopup: false });
      }
    }];

    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {

        this.dialogInstance.hide();
        this.fetchTranslationApi()
      }
    }];



    this.state = {
      value: null,
      data: [{
        text: '',
        originalText: '',
        reviewed: false,
        applied: false,

        source: ''

      }],

      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      showPwd: false,
      viewedId: '-1',
      hideDialog: false,
      hideAddDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      disabled: false,
      query: null,
      toBeReviewed: true,
      successResp: false,
      isValidFetch: false


    };
    this.editImageSrc = "./assets/images/edit2.png";
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.currentSrc = "";
    this.newRowId = "0";
    this.language = "";
    this.projectId = "";
  }

  componentDidMount() {

    this.language = document.getElementById('languageIdDropDown').value;
    this.projectId = localStorage.getItem('currentProjectId');
    setTimeout(() => {
      this.fetchLanguageApi();
      this.fetchByReviewedCheckApi();
    }, 300);

    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      if (document.getElementById('languageIdDropDown') != null) {
        thisController.projectId = event.projectId;
        thisController.fetchLanguageApi(event.projectId);
        thisController.language = document.getElementById('languageIdDropDown').value;
        thisController.projectId = localStorage.getItem('currentProjectId');
        thisController.fetchByReviewedCheckApi(event.projectId);
      }
    });

  }

  notifyEmptyFields() {

    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please fill all the data</b>, {
      position: "top-center"
    });
  }


  editCell(props, e) {
    this.currentSrc = this.src;
    this.markAsBeingEdited(props.original.id);
  }

  markAsBeingEdited(id) {

    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
    this.state.editId = '0';

  }


  fetchTranslationApi = () => {
    var fetchApiController = this;
    var validatedData = this.dataMissing(document.getElementById('languageIdDropDown').value,
      localStorage.getItem('currentProjectId'));

    if (validatedData == true) {

      $.ajax({
        url: "/api/translations",
        async: false,
        method: 'GET',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        data: {
          language: document.getElementById('languageIdDropDown').value,
          projectId: localStorage.getItem('currentProjectId')
        },

        success: function (res) {
          if (res.success === true) {
            fetchApiController.setState({
              data: res.result,
              successResp: true
            });
          } else {
            fetchApiController.setState({
              successResp: false
            });
            fetchApiController.notifyFailedLoad(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }

    else {
      fetchApiController.setState({
        successResp: true
      });

    }
  }



  notifyFailedLoad(response) {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/warn.svg"
        style={{ paddingRight: '0px', height: '20px', width: '20px' }}
        content="" />{response}</b>, {
      position: "top-center"
    });
  }
  dataMissing(language, projectId) {
    if (language == "" || language == null) {
      this.notifyLanguageDataMissing();
      return false;
    }
    else if (projectId == "" || projectId == null) {

      this.notifyProjectDataMissing();
      return false;
    }

    else {

      return true;
    }
  }

  notifyLanguageDataMissing() {
    toast.dismiss();
    this.setState({
      isValidFetch: true
    })
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Oops!you have not selected Indic language for your project</b>, {
      position: "top-center"
    });
  }
  notifyProjectDataMissing() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please select a project</b>, {
      position: "top-center"
    });
  }

  fetchByReviewedCheckApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var fetchApiController = this;
    var validatedData = this.dataMissing(document.getElementById('languageIdDropDown').value, localStorage.getItem('currentProjectId'));
    if (validatedData === true) {
      $.ajax({
        url: "/api/reviewed-trans",
        async: false,
        method: 'GET',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        data: {
          language: document.getElementById('languageIdDropDown').value,
          projectId: projectId
        },
        success: function (res) {
          if (res.success === true) {
            fetchApiController.setState({
              data: res.result,
              successResp: true
            });

          } else {
            fetchApiController.notifyFailedReview(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }
    else {
      fetchApiController.setState({
        successResp: true
      });

    }
  }


  notifyFailedReview(response) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />{response}</b>, {
      position: "top-center"
    });
  }


  updateTranslationApi(props, e) {

    this.state.editedId = "-1";
    var updatedData = {
      id: props.original.id,
      text: document.getElementById("text" + props.index).innerText.trim(),
      originalText: document.getElementById("originalText" + props.index).value,
      reviewed: document.getElementById('reviewed' + props.index).checked,
      applied: document.getElementById('applied' + props.index).checked,

      source: props.original.source



    };
    var validateRes = this.validateCell(props.original.text);
    var upadteTranslationController = this;
    if (validateRes == true) {
      $.ajax({
        url: "/api/translations",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            upadteTranslationController.notifyUpdate();
            upadteTranslationController.fetchByReviewedCheckApi();
          } else {
            upadteTranslationController.notifyFailedUp(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }

      })
    }
  }

  notifyUpdate() {

    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
      &nbsp;&nbsp;Translation Updated Successfully</b>, {
      position: "top-center",

    });
    this.setState({ editedId: "-1" });
  }
  notifyFailedUp(response) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      {response}</b>, {
      position: "top-center"
    });
  }



  deleteTranslationApi = (id) => {
    var deleteConstructorVariables = this;
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    $.ajax({
      url: "/api/translations/" + id,
      async: false,
      method: 'DELETE',
      headers: {
        "Authorization": "Bearer " +
          localStorage.getItem("access_token")
      },
      success: function (res) {
        if (res.success === true) {
          deleteApiViewController.setState({ deleteRow: true });
          deleteConstructorVariables.setState({ hideDeletePopup: false });
          deleteRowViewController.splice(id, 1);
          deleteConstructorVariables.notifyDelete();
          deleteConstructorVariables.fetchTranslationApi();
        } else {
          deleteConstructorVariables.notifyFailedDelete();
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });

  }

  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Translation Deleted Successfully</b>, {
      position: "top-center",

    });

  }


  notifyFailedDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Updated Successfully</b>, {
      position: "top-center",

    });
  }

  fetchLanguageApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var languageController = this;
    $.ajax(
      {
        url: "/api/agent-languages-mlcd",
        async: false,
        method: 'GET',
        data: {
          projectId: projectId
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        success: function (res) {
          if (res.success === true) {

            var loadedLang = res.result;

            languageController.setState({ language: loadedLang });
            var numberOfLanguages = loadedLang.length;
            var ele3 = document.getElementById("languageIdDropDown");
            if (ele3 != "") {
              if (ele3 != null) {
                ele3.innerHTML = "";


                for (var i = 0; i < numberOfLanguages; i++) {
                  ele3.innerHTML = ele3.innerHTML + '<option value="' + loadedLang[i]
                  ['code'] + '">' + loadedLang[i]['name'] + '</option>';
                }
              }
            }
          }
          else {
            languageController.notifyFailedLoadLang();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    )

  }


  notifyFailedLoadLang() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Updated Successfully</b>, {
      position: "top-center",

    });
  }

  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;

    this.state.disabled = false;

    this.fetchTranslationApi();
  }

  handleChecked = () => {

    if (document.getElementById("toBeReviewed").checked == true) {
      this.fetchByReviewedCheckApi();

    }
    else if (document.getElementById("toBeReviewed").checked == false) {
      this.fetchTranslationApi();

    }
  }

  langhandleChange = (e) => {
    this.fetchTranslationApi()
  }

  queryHandleChange = (e) => {
    this.fetchByQueryApi();
  }
  fetchByQueryApi = () => {
    var fetchApiController = this;

    $.ajax({
      url: "/api/translation-search",
      async: false,
      method: 'GET',
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        language: document.getElementById('languageIdDropDown').value,
        projectId: localStorage.getItem('currentProjectId'),
        query: document.getElementById('query').value
      },

      success: function (res) {
        if (res.success === true) {
          fetchApiController.setState({
            data: res.result
          });

        } else {
          fetchApiController.notifyFailedLoadQuer();
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    })
  }
  notifyFailedLoadQuer() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center",

    });
  }

  notifyEmptyFields() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please fill the translation</b>, {
      position: "top-center",

    });
  }
  validateCell(text) {
    if (text == "" || text == null || text == " ") {
      this.notifyEmptyFields();
      return false;
    }

    else {
      return true;
    }
  }
  textHandleChange(props, event) {
    props.original.text = document.getElementById("text" + props.index).innerText;

    this.setState(this.state);


  }

  onKeyPressHandleChange = (event) => {
    if (event.key === "Enter") {
      this.fetchByQueryApi();
    }
  }
  fetchCallDecision = (e) => {
    if (document.getElementById('toBeReviewed').checked == 'true') {
      this.fetchByReviewedCheckApi
    }
    else {
      this.fetchTranslationApi
    }
  }
  render() {
    const { data } = this.state


    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: 'center' }}
        />


        <div className="container-fluid" style={{ display: this.state.successResp ? 'block' : 'none' }}>
          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />

          {/* for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta httpEquiv="x-ua-compatible" content="ie=edge" />
          <div style={{ backgroundColor: '#F9F9FB' }}>
            {/* for checkbox component */}
            <link rel="stylesheet" href="assets/css/Checkbox/Checkboxbutton.css" />
            <link rel="stylesheet" href="assets/css/Checkbox/CheckboxTick.css" />
            <div className="row">
              <div className="col-sm-4"></div></div>

            <div className="row" id="facebookProperties" style={{ marginLeft: '13px' }} >
              <div className="col-sm-9" >
                <h6 className="taglineTxt"></h6>
                <label style={{ marginLeft: '1px' }}>Language</label>
                <select id="languageIdDropDown" className="languageIdDropDown"
                  onChange={this.langhandleChange} placeholder="Select language"
                  style={{
                    width: '23%', height: '30px', borderRadius: '4px',
                    backgroundColor: '#F9F9FB',
                    marginLeft: '16px'
                  }} ></select>
              </div>
            </div>
          </div>
          <div className="row">
            {/* language */}
            <div className="col-sm-4">
              <h6 className="nav-item" style={{
                color: '#282a65',
                marginTop: '20px', marginLeft: '24px', marginLeft: '22px'
              }}>Review Translations</h6>


            </div>

            {/*  review buttons */}
            <div className="col-sm-8" Align="right">
              <div className="input-group search-btn" style={{
                marginTop: '-28px', width: '200px', display: 'inline-block',
                backgroundColor: 'rgb(249, 249, 251)'
              }} >
                <div className="search-icon" >

                  <input className="border-none" type="search" placeholder="Search"
                    onKeyPress={this.onKeyPressHandleChange}
                    aria-label="Search"
                    style={{
                      width: '77%', height: '80%',
                      filterable: true, backgroundColor: 'rgb(249, 249, 251)',
                      font: 'bold', color: 'black'
                    }}
                    id="query" />
                  <button onClick={this.queryHandleChange} style={{
                    border: 'none',
                    backgroundColor: '#F9F9FB'
                  }}>
                    <img src="assets/images/search.svg"
                      style={{ width: '18px' }} /></button>
                </div>
              </div>
              <CheckBoxComponent label="To be reviewed" onClick={this.handleChecked}
                style={{ marginTop: '14px' }} id="toBeReviewed" checked={this.state.toBeReviewed} />
              <button onClick={this.refreshData} className="btn action-button">
                <img src="./assets/images/refresh_white_24dp.png" title="Refresh"></img>
              </button>
              <div>


              </div>
            </div>

          </div>


          <div id="reactTable" style={{ marginLeft: '20px' }}>
            {this.contentEditiable}
            <ReactTable id='reactTable'
              onPageChange={this.refreshData}


              data={data}

              columns={[


                {
                  Header: <b>Original</b>,
                  accessor: 'originalText',
                  sortable: true,
                  filterable: false,


                  Cell: props => (
                    <div
                      Align="left" className="textarea"
                      style={{
                        padding: '8px', width: '98%', borderBottom: 'none', height: '74px',
                        paddingLeft: '2px'
                      }}
                      contentEditable={false}

                      type="text" id={"originalText" + props.index} value={props.original.id == undefined ? "" :
                        props.original.originalText}
                      dangerouslySetInnerHTML={{ __html: props.original.originalText }}
                    ></div>
                  )

                },

                {
                  Header: <b>Translation</b>,
                  accessor: 'text',
                  sortable: false,
                  filterable: false,
                  Cell: props => (
                    <div
                      Align="left" className="textarea"
                      style={{
                        height: '74px', padding: '8px', width: '98%', borderBottom: 'none', height: '74px',
                        border: (props.original.id == "" || props.original.id == this.state.editedId) ?
                          '1px solid #D2D4DC' : 'none',
                        borderRadius: (props.original.id == "" || props.original.id == this.state.editedId) ? '2px' : 'none', paddingLeft: '2px'
                      }}
                      suppressContentEditableWarning
                      contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}
                      type="text" id={"text" + props.index} value={props.original.id == undefined ? "" :
                        props.original.text}
                      dangerouslySetInnerHTML={{ __html: props.original.text }}
                    ></div>
                  )
                },

                {
                  Header: <b>Review</b>,
                  accessor: 'reviewed',
                  sortable: false,
                  width: 100,
                  filterable: false,
                  Cell: props => {
                    return (
                      <div style={{
                        textAlign: 'center'
                        , display: (this.state.isValidFetch == false) ? 'block' : 'none',
                      }}>
                        <label class="switch">
                          <input type="checkbox"
                            id={"reviewed" + props.index}
                            defaultChecked={props.original.reviewed}
                            disabled={props.original.id && props.original.id != this.state.editedId}

                          />
                          <span class="slider round"></span>
                        </label>
                      </div>)
                  }
                },
                {
                  Header: <b>Applied</b>,
                  accessor: 'applied',
                  sortable: false,
                  width: 100,
                  filterable: false,
                  Cell: props => {
                    return (
                      <div style={{ textAlign: 'center', display: (this.state.isValidFetch == false) ? 'block' : 'none' }}>
                        <label class="switch">
                          <input type="checkbox" id={"applied" + props.index}

                            defaultChecked={props.original.applied}
                            disabled

                          />
                          <span class="slider round" style={{ cursor: 'default' }} ></span>
                        </label>
                      </div>)
                  }

                },

                {
                  Header: <b>Source Type</b>,
                  accessor: 'sourceType',
                  sortable: false,
                  filterable: false,
                  Cell: props => (
                    <div>
                      <input type="text" id={"source" + props.index}
                        value={props.original.source}
                        style={{ width: '98%', border: 'none' }}

                        disabled />
                    </div>
                  )

                },

                {
                  Header: <b>Action</b>,
                  sortable: false,
                  width: 100,
                  filterable: false,
                  Cell: props => {
                    return (
                      <div className="container-fluid" style={{
                        textAlign: "center",
                        display: (props.original.source != "") ? 'block' : 'none'
                      }}>
                        <button type="button" className="btn btn-primary pull-right navyblue-btn"
                          onClick={(e) => {
                            ((this.state.data[props.index].id == this.state.editedId)
                              ? this.updateTranslationApi(props, e) : this.editCell(props, e));
                          }}
                          style={{
                            height: '26px', width: '31px', marginRight: '49px',
                            cursor: 'pointer', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                          }}
                        >
                          <img className="img-responsive" title={(props.original.id == undefined) ||
                            (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                            src={(props.original.id == undefined)
                              ?
                              this.saveImageSrc :

                              ((props.original.id
                                != this.state.editedId)
                                ?
                                this.editImageSrc : this.saveImageSrc)}

                          />

                        </button>
                        <button type="button" className="btn btn-primary pull-right navyblue-btn"
                          onClick={() => {
                            (props.original.id) === undefined ?
                              this.fetchTranslationApi() :
                              this.setState({
                                hideDeletePopup: true, propsId: props.original.id
                              })
                          }}
                          style={{
                            height: '26px',
                            width: '31px',
                            marginTop: '-31px',
                            backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', cursor: "pointer"
                          }}
                        >
                          <img src="assets/images/baseline_delete_white_24dp.png"
                            title='Delete'
                            style={{ marginTop: '-5px' }}
                          />

                        </button>
                      </div>
                    )
                  }
                }
              ]}
              defaultPageSize={10}
              pageSizeOptions={[5, 10, 15]}
              style={{ backgroundColor: 'white' }}
            />
            <ToastContainer className="Toast-at-center" />





            {/*Dialog Component For Deletion Confirmation*/}
            <DialogComponent width='400px' animationSettings={this.settings}
              header='Translations' showCloseIcon={true} buttons={this.buttons}
              ref={dialog => this.dialogInstance = dialog}
              visible={this.state.hideDeletePopup} close={this.dialogClose}>
              <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                content="" />&nbsp;Do you want to delete the Translation?<br />Note: Press 'Yes' to delete or press 'No' to decline.

            </DialogComponent>




          </div>

        </div>
      </div>

    )
  }
}
export default Translations;


// WEBPACK FOOTER //
// ./src/projectmgmt/MultiLingualData/Translations.js